import React, { useState, useEffect } from 'react';

const ServicesSection = () => {
  const [activeTab, setActiveTab] = useState('Digital Services');
  const [slide, setSlide] = useState(false);

  const servicesData = {
    'Digital Services': [
      {
        title: 'Server Solutions',
        description:
          'We provide dedicated hosting for unparalleled control, along with scalable cloud server management for optimal reliability.',
      },
      {
        title: 'Web Hosting',
        description:
          'We utilize our advanced cloud computing capabilities and infrastructure to offer unlimited web hosting services.',
      },
      {
        title: 'CCTV Surveillance',
        description:
          'Equipped with high-definition cameras and advanced analytics, our systems offer real-time monitoring and remote access.',
      },
      {
        title: 'Storage Solutions',
        description:
          'We offer a range of options, including cloud storage for flexible access and sharing, as well as Network Attached Storage (NAS) for robust, on-premises data storage',
      },
      {
        title: 'Software Development',
        description:
          'Our experts utilize the latest technologies and industry standards to create secure, high-performing websites, mobile and systems applications.',
      },
      {
        title: 'IT Support',
        description:
          'Our IT help desk services deliver prompt solutions to provide immediate support to our customers and their clients.',
      },
    ],
    'Hosting Services': [
      {
        title: 'SSL Certificates',
        description:
          'Obtain SSL certificates to establish encrypted connections between your server and visitors, ensuring secure data transmission.',
      },
      {
        title: 'Email Hosting',
        description:
          'Providing email hosting services with custom email addresses, spam filtering, and integration with email clients.',
      },
      {
        title: 'Cloud Hosting',
        description:
          'Offering scalable hosting solutions that utilize cloud infrastructure, providing flexibility and reliability.',
      },
      {
        title: 'E-Commerce Hosting',
        description:
          'Hosting tailored for online stores, including features like shopping cart integration, SSL certificates, and scalability for high traffic.',
      },
      {
        title: 'Virtual Private Server (VPS) Hosting',
        description:
          'Providing virtual servers with dedicated resources, offering more control and scalability compared to shared hosting',
      },
      {
        title: 'Database Hosting',
        description:
          'Providing virtual servers with dedicated resources, offering more control and scalability compared to shared hosting',
      },
    ],
    'Cloud Services': [
      {
        title: 'Backup & Disaster Recovery',
        description:
          'Cloud-based backup and recovery solution for mobile devices, laptops, etc. Boot ready in minutes to run your systems.',
      },
      {
        title: 'Cloud Application Backup',
        description:
          'Safeguard your data on Microsoft 365, Google Workspace, Box, Dropbox, and Salesforce against accidental deletions,threats etc.',
      },
      {
        title: 'Cloud Backup',
        description:
          'Our cloud backup solutions ensure that your data is safe and easily recoverable, providing peace of mind for your business.',
      },
      {
        title: 'Cloud Networking',
        description:
          'Seamlessly connect and manage your virtual networks with our secure cloud networking solutions.',
      },
      {
        title: 'Cloud Security',
        description:
          'Protect your applications and data with our robust cloud security services.',
      },
      {
        title: 'Cloud Virtual Storage',
        description:
          'Our public cloud offers a robust, high-performance storage solution.',
      },
    ],
    
  };

  // Use effect to trigger the slide effect when the active tab changes
  useEffect(() => {
    if (activeTab) {
      setSlide(true);
      const timeout = setTimeout(() => setSlide(false), 500); // Duration should match the animation duration
      return () => clearTimeout(timeout);
    }
  }, [activeTab]);

  const renderServices = () => {
    return servicesData[activeTab].map((service, index) => (
      <div
        key={index}
        className={`bg-white border border-blue-200 hover:bg-gray-100 rounded-md shadow-sm p-6 flex flex-col justify-between`}
        style={{
          animation: slide ? 'slideIn 0.7s ease-out' : 'none',
        }}
      >
        <h3 className="text-lg mb-2 text-blue-900">
          {service.title}
        </h3>
        <p className="text-gray-700">{service.description}</p>
      </div>
    ));
  };

  return (
    <div className="bg-[#f4f6f7] shadow-2xl max-w-screen-xl mx-auto px-4 py-8">
      <h2 className="text-2xl text-blue-800 font-semibold text-center mb-6">
        Our Services
      </h2>
      {/* Tabs navigation */}
      <div className="flex flex-col justify-center items-center mb-6 space-y-2 sm:space-y-0 sm:flex-row sm:space-x-2">
        {Object.keys(servicesData).map((tab) => (
          <button
            key={tab}
            aria-pressed={activeTab === tab}
            className={`w-40 h-14 sm:w-40 mx-2 px-4 py-2 text-center text-sm sm:text-base font-medium rounded border-2 transition-transform duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 ${
              activeTab === tab
                ? 'bg-[#023B8D] text-[#C5B358] '
                : 'bg-transparent text-[#023B8D]'
            } hover:bg-[#C5B358] hover:text-[#023B8D]`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>


      {/* Main card with static size for all services */}
      <div
        className="rounded-lg p-6 overflow-auto"
        style={{
          width: '100%',
          maxWidth: '980px',
          height: '530px',
          margin: '-23px auto 0 auto',
        }}
      >
        {/* Card grid layout */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {renderServices()}
        </div>
      </div>

      {/* Inline style for slide animation */}
      <style>{`
        @keyframes slideIn {
          from {
            transform: translateX(-100%);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
};

export default ServicesSection;
